import { getMetricsAtom } from "@tokenterminal/core/data/store/metrics-atom"
import { type MetricConfiguration } from "@tokenterminal/tt-analytics-api-types/dist/api/metrics"
import { fetchAtom } from "data/api/useFetch"
import { atom, useAtomValue } from "jotai"

const ENDPOINT = "/v3/internal/metrics" as const

export function convertMetricsToDictionary(
  metrics: Array<MetricConfiguration>
) {
  return metrics.reduce(
    (acc, metric) => {
      acc[metric.slug] = metric
      return acc
    },
    {} as Record<string, MetricConfiguration>
  )
}

export const metricsMetaAtom = atom(async (get) => {
  const [{ ok: availableMetricsPayload }, { ok: metricConfigurationPayload }] =
    await Promise.all([get(fetchAtom(ENDPOINT)), get(getMetricsAtom)])

  if (!metricConfigurationPayload || !availableMetricsPayload) {
    return []
  }

  const metricsDictionary = convertMetricsToDictionary(
    metricConfigurationPayload.data
  )

  const result: Array<MetricConfiguration> = []
  for (const project of availableMetricsPayload.data) {
    result.push(metricsDictionary[project.slug])
  }

  return result.sort((a, b) => a.index! - b.index!)
})

export function useMetricsMeta() {
  return useAtomValue(metricsMetaAtom)
}
